<template>
  <div class="noEvents">
    <SmallLabel>No upcoming events</SmallLabel>
    <p class="noEvents-emoji">{{ randomEmoji }}</p>
  </div>
</template>

<script>
import SmallLabel from './SmallLabel.vue'
const EmojiSet = [
  '(>_<)',
  '(･_･)',
  '\\(o_o)/',
  '{•̃_•̃}',
  '(·.·)',
  '(◔_◔)',
  'ʕ•ᴥ•ʔ',
  '(¬_¬)',
  '(¬‿¬)',
  '(ᵔᴥᵔ)',
  '(⌐■_■)',
  'ಠ╭╮ಠ',
  'ಠ‿ಠ',
  '(ಠ_ಠ)',
  '\\_(ʘ_ʘ)_/'
]

export default {
  components: { SmallLabel },
  data() {
    return {
      randomEmoji: EmojiSet[Math.floor(Math.random() * EmojiSet.length)]
    }
  }
}
</script>

<style lang="scss" scoped>
.noEvents {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: $white;
}

.noEvents-label {
  font-size: $size-small;
  margin-bottom: 0.5em;
  font-style: italic;
  opacity: 0.8;
}

.noEvents-emoji {
  font-family: $family-monospace;
  font-size: 3em;
  opacity: 0.5;
  line-height: 1;
}
</style>
